import type { Size } from '../contexts/CrosswordSettingsContext'

/**
 * Pixel-based size configuration for grid cells
 * Used by GridDisplay, GridWord, GridLetter, and DraggablePair
 */
export const gridSizeConfig: Record<Size, { cell: number; font: number }> = {
  '2xs': { cell: 10, font: 7 },
  'xs': { cell: 14, font: 8 },
  'sm': { cell: 18, font: 10 },
  'base': { cell: 22, font: 12 },
  'lg': { cell: 28, font: 14 },
  'xl': { cell: 32, font: 16 },
  '2xl': { cell: 36, font: 18 },
  '3xl': { cell: 44, font: 20 },
}

/**
 * Get cell size in pixels for a given size setting
 */
export function getCellSize(size: Size): number {
  return gridSizeConfig[size]?.cell ?? 22
}

/**
 * Get font size in pixels for a given size setting
 */
export function getFontSize(size: Size): number {
  return gridSizeConfig[size]?.font ?? 12
}
